import { createUseProvidedContext as e } from "./index174.mjs";
import { SideNavContext as t } from "./context5.mjs";
const i = e(
  t,
  "SideNavContext"
);
export {
  i as useSideNav
};
//# sourceMappingURL=useSideNav2.mjs.map
